import { DocViewerRenderers } from '@cyntler/react-doc-viewer';
import DocViewer from '@cyntler/react-doc-viewer';
import { Box, Typography } from '@mui/material';
import { fileTypeToIconMap } from 'components/SVG/fileType/fileTypeMap';
import { useBlobStorage } from 'hooks/useBlobStorage';
import React from 'react';
import { useWorkspaceStore } from 'stores';
import { ListOptionsType } from 'types/common/DropdownOption';
import { parseJSONCleaned } from 'utilities/index';

type DocumentType = {
  uri: string;
  fileType: string;
  fileName: string;
};

type FileNodeType = {
  files: {
    fileSize: string;
    mimeType: string;
    id: string;
    isDeleted: boolean;
    originalFileName: string;
    url: string;
  }[];
};

type FileNodeProps = {
  initialContent?: string;
  onError?: ((errorMessage: string) => void) | undefined;
  setNodeSpecificOptions: React.Dispatch<
    React.SetStateAction<ListOptionsType[]>
  >;
};

function FileNode({ initialContent }: FileNodeProps) {
  const nodeData = parseJSONCleaned<FileNodeType>(initialContent);
  const file = nodeData?.files?.[0];

  const [document, setDocument] = React.useState<DocumentType | null>();
  const fileURLSections = file?.url.split('/');
  const fileName = fileURLSections?.[fileURLSections.length - 1];
  const fileType = fileName?.split('.')[1];

  const { workspace } = useWorkspaceStore();

  const { getBlockBlobClient } = useBlobStorage(
    workspace?.attributes?.containerName || 'temp'
  );

  React.useEffect(() => {
    if (document) {
      return;
    }
    getBlockBlobClient(fileName || '').then((data) => {
      setDocument({
        fileType: fileType || '',
        uri: data?.url || '',
        fileName: fileName || '',
      });
    });
  }, [document, fileName, fileType, getBlockBlobClient]);

  return (
    <Box display='flex' alignItems='center' flexDirection='column' gap={1}>
      <Box>{fileTypeToIconMap[file?.mimeType || '']}</Box>
      <Typography>{file?.originalFileName}</Typography>
    </Box>
  );
}

export default FileNode;
